<template>
  <div class="wrap">
    <div class="item">
      <div>
        <p class="title">{{item.faceValue}}元话费充值</p>
        <p class="time">{{item.createTime}}</p>
      </div>
      <div>
        <p class="point">{{item.pricePoint}}积分</p>
        <template v-if="item.chargeStatus == 0">
          <p class="status">等待充值</p>
        </template>
        <template v-else-if="item.chargeStatus == 1">
          <p class="status">正在充值</p>
        </template>
        <template v-else-if="item.chargeStatus == 2">
          <p class="status">交易成功</p>
        </template>
        <template v-else>
          <p class="status">交易失败</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"]
};
</script>

<style lang="less" scoped>
.item {
  p {
    margin: 0;
  }
  background: #fff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  padding: 4vw;
  margin-bottom: 4vw;

  .title {
    color: #333;
    font-size: 4vw;
    margin-bottom: 3.5vw;
  }
  .time {
    font-size: 3.5vw;
    color: #999;
  }
  .point {
    font-size: 4vw;
    color: #ff3340;
    margin-bottom: 3.5vw;
    text-align: right;
  }
  .status {
    font-size: 3.5vw;
    color: #999;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/charge/ListItem.vue